export enum EUserRole {
  ADMIN = "admin",
  SUPER_ADMIN = "super admin",
  PCN_ADMIN = "pcn admin",
  SALES_OFFICER = "sales officer",
  PURCHASE_OFFICER = "purchase officer",
  INVENTORY_OFFICER = "inventory officer",
  DRIVER = "driver",
  HOSPITAL_HEAD = "hospital head",
  HEAD_OF_PHARMACY = "head of pharmacy",
  HOSPITAL_ACCOUNTANT = "hospital accountant",
  MINISTRY_OF_HEALTH_DG = "ministry of health dg",
  MINISTRY_OF_HEALTH_SECRETARY = "ministry of health secretary",
}

export enum ECompanyType {
  WHOLESALER = "wholesaler",
  IMPORTER = "importer",
  DELIVERY_SERVICE_PROVIDER = "delivery service provider",
  RETAILER = "retailer",
  DISTRIBUTOR = "distributor",
  MANUFACTURER = "manufacturer",
}

export enum EUserStatus {
  ACTIVATED = "activated",
  DEACTIVATED = "deactivated",
  PENDING = "pending",
}

export enum PCNRegStatus {
  UNINITIALIZED = "uninitialized",
  INITIALIZED = "initialized",
  COMPLETED = "completed",
}

export enum UserRole {
  Manufacturer = "Manufacturer",
  Distributor = "Distributor",
  Retailer = "Retailer",
}
